import http from "./HttpService";

const endpoint = process.env.VUE_APP_BASE_URL;


export function getUserPersonalInfo(accountId) {
  return http.get(`Accounts/${accountId}/personal-info/manual`, {
    baseURL: endpoint,
  });
}

export function getUserAddress(accountId) {
  return http.get(`Accounts/${accountId}/address-postal-code`, {
    baseURL: endpoint,
  });
}

export function rejectPersonalInfo(accountId) {
  return http.put(
    `Accounts/${accountId}/personal-info/manual/reject`,
    {},
    {
      baseURL: endpoint,
    }
  );
}

export function approvePersonalInfo(accountId, data) {
  return http.put(`/Accounts/${accountId}/personal-info/manual/approve`, data, {
    baseURL: endpoint,
  });
}

export function rejectAddress(accountId) {
  return http.put(
    `Accounts/${accountId}/address-postal-code/reject`,
    {},
    {
      baseURL: endpoint,
    }
  );
}

export function approveAddress(accountId, data) {
  return http.put(`/Accounts/${accountId}/address-postal-code/approve`, data, {
    baseURL: endpoint,
  });
}

export function getUserAccountVerification(accountId) {
  return http.get(`/Accounts/${accountId}/verifications`, {
    baseURL: endpoint,
  });
}

export function updateAccountApproval(accountId, data) {
  return http.put(`Accounts/approval/${accountId}`, data, {
    baseURL: endpoint,
  });
}

export function getAccountVerification(accountId) {
  return http.get(`Accounts/${accountId}/verifications`, {
    baseURL: endpoint,
  });
}
